import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "🔗", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Registro de Permanência", -1)


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'PermanenceLinkRow' },
  __name: 'PermanenceLinkRow',
  props: {
    direction: {},
    stationLabel: {},
    doctorStationId: {},
    stationId: {}
  },
  emits: ["navigate"],
  setup(__props: any) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "w-full flex items-center gap-1.5 text-sm text-primary bg-primary5 border border-dashed border-primary20 rounded-md px-3 py-2 mt-2 text-left hover:bg-primary10/40 transition-colors",
    "data-testid": "permanence-link-row",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', _ctx.stationId)))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("span", null, [
      _createTextVNode("— " + _toDisplayString(_ctx.direction === 'forward' ? 'continuou no plantão' : 'veio do plantão') + " ", 1),
      _createElementVNode("u", null, _toDisplayString(_ctx.stationLabel), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.direction === 'forward' ? '→' : '←'), 1)
    ])
  ]))
}
}

})